import { render, staticRenderFns } from "./list-fulfillment.vue?vue&type=template&id=ed45171e"
import script from "./list-fulfillment.vue?vue&type=script&lang=js"
export * from "./list-fulfillment.vue?vue&type=script&lang=js"
import style0 from "./list-fulfillment.vue?vue&type=style&index=0&id=ed45171e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports